import api from '@/api'

export default {
  all() {
    return api.get('/email-templates')
  },

  save(template) {
    if (template.id) {
      return api.post(`/email-templates/${template.id}`, { email_template: template })
    } else {
      return api.post('/email-templates', { email_template: template })
    }
  },
}
